import React from "react";

export function Checkbox({ isSelected, onChange,children,id,value }) {
  return (
    <>
      <input type="checkbox" style={{display: "none"}} />
      <label className="checkbox checkbox-lg checkbox-single">
        <input type="checkbox" id={id} value={value} checked={isSelected} onChange={onChange}/>
        {children}
        <span />
      </label>
    </>
  );
}
